import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import './styles/globalWrapper.scss';

const GlobalWrapper = ({ children }) => (
  <div className="c-vi-global-wrapper">
    <Helmet>
      <meta name="viewport" content="width=670, initial-scale=1, maximum-scale=1" />
    </Helmet>

    {children}
  </div>
);

GlobalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GlobalWrapper;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/GlobalWrapper.jsx